import DownloadableFile from '@components/ChemicalProduct/ChemicalProductDetails/GeneralInformation/DownloadableFile';
import styles from '../Components/styles/InventoryOverviewPopup.module.scss';
import stylesMobile from '../Components/styles/InventoryOverviewMobile.module.scss';
type Props = {
  fileData: any[];
  isMobile: boolean;
};

const DownloadableFileWrapper = ({ fileData, isMobile }: Props) => {
  return (
    <div
      className={
        isMobile ? `${stylesMobile.pdfMobile}` : `${styles.inlineElements} ${styles.pdfButton}`
      }
    >
      {fileData.length > 0 &&
        fileData.map(file => (
          <DownloadableFile fileName={file.name} uploadId={file.id} key={file.id} />
        ))}
    </div>
  );
};

DownloadableFileWrapper.defaultProps = {
  isMobile: false,
};

export default DownloadableFileWrapper;
